import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'

import { RegisterPaymentOptions } from '../../../../../../contexts/billsEmberConnectionContext'
import { EmberRoute } from '../../../../../../enums/emberRoute'
import { bankPaymentActionHandlers } from './consts/bankPaymentActionHandlers'
import { billActionHandlers } from './consts/billsActionHandlers'
import { daybooksActionHandlers } from './consts/daybooksActionHandles'
import { invoiceActionHandlers } from './consts/invoicesActionHandlers'
import { salesTaxPaymentsActionHandlers } from './consts/salesTaxPaymentsActionHandlers'
import { salesTaxReturnsActionHandlers } from './consts/salesTaxReturnsActionHandlers'

type StaticActionHandlerProps = {
  generateUrl?: (route: EmberRoute, id?: string) => string
  handleCopyToDaybook: () => void
  handleRegisterPaymentForBill: () => void
  handleVoidInvoice: () => void
  locationSearch: string
  openModal: (modalId: string) => void
  organizationUrl: string | undefined
  originatorId: string
  registerPaymentForInvoice: (props: RegisterPaymentOptions) => void
  reverseDaybookTransactionModalId: string
  track: (eventName: string, eventProperties?: Record<string, unknown>) => void
  transactionId: string
  transitionTo: (url: string) => void
  voidBillPaymentModalId: string
  voidBillModalId: string
  voidDaybookTransactionModalId: string
  voidVatDeclarationPaymentModalId: string
  voidVatDeclarationModalId: string
}

export type StaticActionHandler = (props: StaticActionHandlerProps) => void

export const actionHandlerMap: Partial<Record<TransactionOriginatorType, Record<string, StaticActionHandler>>> = {
  [TransactionOriginatorType.BankPayment]: bankPaymentActionHandlers,
  [TransactionOriginatorType.Bill]: billActionHandlers,
  [TransactionOriginatorType.DaybookTransaction]: daybooksActionHandlers,
  [TransactionOriginatorType.Invoice]: invoiceActionHandlers,
  [TransactionOriginatorType.SalesTaxPayment]: salesTaxPaymentsActionHandlers,
  [TransactionOriginatorType.SalesTaxReturn]: salesTaxReturnsActionHandlers,
} as const
